export const registerAPI='https://www.ccwork.com.cn/interface/index.php'